import currencyXAF from '@/filters/currency.js'

export default {
  methods: {
    /**
     * Return the BCP-47 locale tag for the current i18n language.
     * Extend this map when adding more languages.
     */
    getLocaleTag () {
      const lang = (this.$i18n && this.$i18n.locale) || 'en'
      const map = { en: 'en-US', fr: 'fr-FR' }
      return map[lang] || 'en-US'
    },

    /**
     * Format a number as XAF currency.
     * @param {number|string} value
     * @param {boolean}       showSymbol  Append " XAF" suffix
     */
    formatCurrency (value, showSymbol = true) {
      const num = Number(value)
      if (isNaN(num)) return showSymbol ? '0 XAF' : '0'

      const lang = (this.$i18n && this.$i18n.locale) || 'en'

      if (showSymbol) {
        return currencyXAF(num, lang)
      }

      return num.toLocaleString(this.getLocaleTag(), {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
    },

    /**
     * Format a plain number with locale-appropriate thousands separator.
     * @param {number|string} value
     * @param {number}        decimals
     */
    formatNumber (value, decimals = 0) {
      const num = Number(value)
      if (isNaN(num)) return '0'
      return num.toLocaleString(this.getLocaleTag(), {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      })
    },

    /**
     * Format a percentage value with locale-appropriate decimal separator.
     * @param {number|string} value    Already a percentage (12.3 → "12.3%")
     * @param {number}        decimals
     */
    formatPercentage (value, decimals = 1) {
      const num = Number(value)
      if (isNaN(num)) return '0%'
      return num.toLocaleString(this.getLocaleTag(), {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      }) + '%'
    },

    /**
     * Return the currency symbol/code.
     */
    getCurrencySymbol () {
      return 'XAF'
    },

    /**
     * Parse a locale-formatted currency string back to a plain number.
     * Handles both en ("1,234.56") and fr ("1 234,56") formats.
     * @param {string|number} value
     */
    parseCurrency (value) {
      if (typeof value === 'number') return value
      if (typeof value !== 'string') return 0

      // Remove currency code, spaces used as thousands separators, then
      // normalise the decimal separator to a dot before parsing.
      const lang = (this.$i18n && this.$i18n.locale) || 'en'
      let clean = value.replace(/XAF/g, '').trim()

      if (lang === 'fr') {
        // French: thousands = space, decimal = comma  →  "1 234,56"
        clean = clean.replace(/\s/g, '').replace(',', '.')
      } else {
        // English: thousands = comma, decimal = dot  →  "1,234.56"
        clean = clean.replace(/,/g, '')
      }

      const parsed = parseFloat(clean)
      return isNaN(parsed) ? 0 : parsed
    }
  }
}
